import { useUser } from '@hooks/useUser';
import { UserViewType } from '@model/User';
import { createMemo } from '@packages/react';
import { renderChildren } from '@packages/react/lib/renderChildren';
import { separate } from '@packages/strings';
import { ForceUserViewContext } from '@packages/user/lib/ForceUserView';
import { ReactElement, useContext } from 'react';

interface UserViewProps {
    view: UserViewType;
    not?: boolean;
    children: any;
}

export const UserView = createMemo<UserViewProps>(
    (props): ReactElement | null => {
        const forcedView = useContext(ForceUserViewContext);
        const { view, not, children } = props;

        const user = useUser();
        const views = separate(view, ',');

        if (user) {
            const matchViews = views.filter((item) => (forcedView ? item === forcedView : user.$is(item)));

            if (not && matchViews.length > 0) {
                return null;
            } else if (!not && matchViews.length === 0) {
                return null;
            }
        } else {
            return null;
        }

        return renderChildren(children);
    },
    { displayName: 'UserView' },
);
